import {createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
import {
  zadSupplierByIdUrl,
  zadSuppliersUrl,
  zadSupplierStatusUrl,
  zadSupplierUpdateUrl,
} from '../../api'
import {buildZadListQuery} from '../zad/query'
import {parseZadApiError} from '../zad/errors'
import {toZadSupplierPayload} from '../zad/supplierHelpers'
import {
  CreateZadSupplierRequest,
  FetchZadSupplierByIdRequest,
  FetchZadSuppliersRequest,
  UpdateZadSupplierRequest,
  UpdateZadSupplierStatusRequest,
} from './types'

export const fetchZadSuppliers = createAsyncThunk(
  'zadSuppliers/fetch',
  async (payload: FetchZadSuppliersRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(`${zadSuppliersUrl}?${buildZadListQuery(payload)}`)
      const {suppliers, total, totalPages} = res.data || {}
      return {
        success: true as const,
        suppliers: Array.isArray(suppliers) ? suppliers : [],
        total: typeof total === 'number' ? total : 0,
        totalPages: typeof totalPages === 'number' ? totalPages : 0,
      }
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)

export const fetchZadSupplierById = createAsyncThunk(
  'zadSuppliers/fetchById',
  async (payload: FetchZadSupplierByIdRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(zadSupplierByIdUrl(payload.id))
      return {
        success: true as const,
        supplier: res.data.supplier,
      }
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)

export const createZadSupplier = createAsyncThunk(
  'zadSuppliers/create',
  async (payload: CreateZadSupplierRequest, {rejectWithValue}) => {
    try {
      const body = toZadSupplierPayload(payload)
      const res = await axios.post(zadSuppliersUrl, body)
      return {
        success: true as const,
        supplier: res.data.supplier,
      }
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)

export const updateZadSupplier = createAsyncThunk(
  'zadSuppliers/update',
  async (payload: UpdateZadSupplierRequest, {rejectWithValue}) => {
    try {
      const {id, ...values} = payload
      const body = toZadSupplierPayload(values)
      const res = await axios.post(zadSupplierUpdateUrl(id), body)
      return {
        success: true as const,
        supplier: res.data.supplier,
      }
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)

export const updateZadSupplierStatus = createAsyncThunk(
  'zadSuppliers/updateStatus',
  async (payload: UpdateZadSupplierStatusRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(zadSupplierStatusUrl(payload.id), {
        isActive: payload.isActive,
      })
      return {
        success: true as const,
        supplier: res.data.supplier,
      }
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)
